import { Expose, Transform, Type } from '@nts/std/serialization';
import { DateTimeOffset, FieldTypes } from '@nts/std/types';
import { FieldMetaDataInterface, MetaDataDescriptionsInterface } from '@nts/std/interfaces';
import { MetaDataDescriptions } from '../meta-data/meta-data-descriptions';

export abstract class FieldMetaData implements FieldMetaDataInterface {

  constructor() {
    this.descriptions = new MetaDataDescriptions();
    this.customDescriptions = new MetaDataDescriptions();
    this.isExtension = false;
  }

  @Expose()
  name: string;

  @Expose()
  path: string;

  @Expose()
  isFullColumn: boolean;

  @Expose()
  position: number;

  @Expose()
  isAdditionalField: boolean;

  @Expose()
  isVisible: boolean;

  @Expose()
  isExtension: boolean;

  @Expose()
  isDisabled: boolean;

  @Expose()
  @Type(() => MetaDataDescriptions)
  descriptions: MetaDataDescriptionsInterface;

  @Expose()
  @Type(() => MetaDataDescriptions)
  customDescriptions: MetaDataDescriptionsInterface;

  @Expose()
  fullPathName?: string;

  @Expose()
  fullPathDescription?: string;

  @Expose()
  isAdditionalRequired?: boolean;

  @Expose()
  isOriginalRequired?: boolean;

  @Expose()
  stringDefaultValue?: string;

  @Expose()
  numericDefaultValue?: number;

  @Expose()
  boolDefaultValue?: boolean;

  @Expose()
  @Type(() => DateTimeOffset)
  @Transform(DateTimeOffset.transform)
  dateTimeOffsetDefaultValue?: DateTimeOffset;

  @Expose()
  dateTimeDefaultValue?: Date;

  @Expose()
  readonly shortName: string;

  @Expose()
  readonly displayName: string;

  @Expose()
  readonly description: string;

  abstract getFieldType(): FieldTypes;

  get fieldType(): FieldTypes {
    return this.getFieldType();
  }
}
